import api from "../../index";

export const GetAllConfigurationApi = (params) => api.get(`appsettings/getall-configuration-thres-hold?${params}`);
export const UpdateUserStatusApi = (data) => api.post('appsettings/update-thres-hold', data);
export const GetAllCommissionApi = (params) => api.get(`ibusermaster/get-deal-threshold-data?${params}`);